if (!customElements.get("copow-popup")) {
  class DeliveryOptions extends HTMLElement {
    constructor() {
      super();
      document.body.style.overflow = "hidden";
      this.appURL = "https://copow-delivery-app-cac23e803740.herokuapp.com";
      this.checkoutSelectors =
        'button[name="checkout"], input[name="checkout"], #checkout, #dynamic-checkout-cart, #cart-checkout';
      this.metaData = {
        message:
          "Switching to {{method}} will reset your shopping cart. Any items in your cart will be removed.",
        title: "Do you want to continue?",
        ctaPrimary: "Yes, continue to {{method}}",
        ctaSecondary: "No, proceed with {{previousMethod}}",
      };
      this.appSettings = {
        type: "different",
        zipCodes: "10001,10002,838**",
        languages: {
          en: {
            language: "en-US",
            time_label: "Select time",
            time_format: "%l:%M %p", //%l:%M %p => 2:30 PM
            date_format: "M d, Y",
            calendar_label: "Choose a date",
            delivery_min_value_error: "Minimum value for delivery is {{value}}",
            error_message: "Please select date / time",
            shipping_label: "Shipping",
            local_delivery_label: "Local Delivery",
            pickup_label: "Store Pickup",
            widget_footer_shipping:
              "Perishables ship Express 2-3 day service.\nNon-perishables ship ground saver.",
            widget_footer_delivery: "*Deliveries occur between 8am-6pm",
            widget_footer_pickup: "*Pick up during business hours",
            shipping_enabled: true,
            store_pickup_enabled: true,
            local_delivery_enabled: true,
          },
        },
        sameScheduleForLocations: false,
        delivery: {
          enable: true,
          manage: true,
          availability: {
            dateTimeType: "range",
            sameAvailability: true,
            availability: {
              Sun: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Mon: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Tue: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Wed: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Thu: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Fri: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
              Sat: {
                slots: [
                  {
                    start: "10:00 AM",
                    end: "01:00 PM",
                    maxOrders: "",
                  },
                ],
                maxOrders: "15",
              },
            },
          },
          preparationTime: {
            enabled: true,
            optionSelected: "customized",
            leadTimes: {
              Sunday: "1",
              Monday: "0",
              Tuesday: "0",
              Wednesday: "4",
              Thursday: "0",
              Friday: "0",
              Saturday: "0",
            },
            cutOffTimes: {
              Sunday: "",
              Monday: "",
              Tuesday: "",
              Wednesday: "",
              Thursday: "",
              Friday: "",
              Saturday: "",
            },
          },
          blockoutDates: {
            availableDays: "7",
            dates: [
              {
                date: "2025-03-19",
                timeRange: "11:00 AM - 04:00 PM",
              },
              {
                date: "2025-03-20",
                timeRange: "11:00 AM - 04:00 PM",
              },
              {
                date: "2025-03-21",
                timeRange: "11:00 AM - 04:00 PM",
              },
              {
                date: "2025-03-22",
                timeRange: "11:00 AM - 04:00 PM",
              },
              {
                date: "2025-03-23",
                timeRange: "11:00 AM - 04:00 PM",
              },
            ],
          },
          minOrderValue: {
            minOrderValue: "15",
          },
          productAvailability: {
            selectedOption: "tags",
            tags: ["123", "1"],
          },
        },
        pickup: {},
        shipping:
          '{"enableStandardShipping":true,"manageShippingCalendar":true,"availability":{"dateTimeType":"none","sameAvailability":false,"availability":{"Sun":{"maxOrders":"","slots":[]},"Mon":{"maxOrders":"","slots":[]},"Tue":{"maxOrders":"","slots":[]},"Wed":{"maxOrders":"","slots":[]},"Thu":{"maxOrders":"","slots":[]},"Fri":{"maxOrders":"","slots":[]},"Sat":{"maxOrders":"","slots":[]}}},"preparationTime":{"enabled":false,"optionSelected":"customized","leadTimes":{"Sunday":"0","Monday":"0","Tuesday":"0","Wednesday":"0","Thursday":"0","Friday":"0","Saturday":"0"},"cutOffTimes":{"Sunday":"","Monday":"","Tuesday":"","Wednesday":"","Thursday":"","Friday":"","Saturday":""}},"blockoutDates":{},"minOrderValue":"","productAvailability":{"selectedOption":"all","tags":[]}}',
        locations: {
          stores: [
            {
              id: 123,
              name: "Location Name",
              address: "555 Street Name, City, State, Zip",
              phone: "(555)-555-5555",
              city: "Coeur d Alene",
              zip: "83814",
              province: "Idaho",
              country: "US",
              country_code: "US",
              province_code: "ID",
              delivery: {
                enabled: true,
                managed: true,
                availability: {
                  dateTimeType: "only_date",
                  sameAvailability: false,
                  availability: {
                    Sun: {
                      slots: [
                        {
                          start: "10:00 AM",
                          end: "01:00 PM",
                          maxOrders: "",
                        },
                      ],
                      maxOrders: "15",
                    },
                  },
                },
                preparationTime: {
                  enabled: true,
                  optionSelected: "customized",
                  leadTimes: {
                    Sunday: "1",
                    Monday: "0",
                    Tuesday: "0",
                    Wednesday: "4",
                    Thursday: "0",
                    Friday: "0",
                    Saturday: "0",
                  },
                  cutOffTimes: {
                    Sunday: "",
                    Monday: "",
                    Tuesday: "",
                    Wednesday: "",
                    Thursday: "",
                    Friday: "",
                    Saturday: "",
                  },
                },
                blockoutDates: {
                  availableDays: "7",
                  dates: [
                    {
                      date: "2025-03-19",
                      timeRange: "11:00 AM - 04:00 PM",
                    },
                    {
                      date: "2025-03-20",
                      timeRange: "11:00 AM - 04:00 PM",
                    },
                    {
                      date: "2025-03-21",
                      timeRange: "11:00 AM - 04:00 PM",
                    },
                    {
                      date: "2025-03-22",
                      timeRange: "11:00 AM - 04:00 PM",
                    },
                    {
                      date: "2025-03-23",
                      timeRange: "11:00 AM - 04:00 PM",
                    },
                  ],
                },
                minOrderValue: {
                  minOrderValue: "15",
                },
              },
              pickup: {},
            },
            {
              id: 3233,
              name: "3500 N. Government Way",
              address: "3500 N. Government Way, Coeur d Alene, 83814",
              phone: "(555)-555-5555",
              city: "Coeur d Alene",
              zip: "83814",
              province: "Idaho",
              country: "US",
              country_code: "US",
              province_code: "ID",
            },
            {
              id: 345,
              name: "Kitchen",
              address: "4226 West Riverbend Avenue, Post Falls, 83854",
              phone: "(555)-555-5555",
              city: "Coeur d Alene",
              zip: "83814",
              province: "Idaho",
              country: "US",
              country_code: "US",
              province_code: "ID",
            },
          ],
        },
      };
      this.selectors = {
        popup: "#copow-popup",
        buttons: ".button-type-delivery",
        confirmationMessage: ".delivery-confirmation-popup__content--message",
        confirmationTitle: ".delivery-confirmation-popup__content--title",
        confirmationCtaPrimary:
          ".delivery-confirmation-popup__content--buttons .button--cta-primary",
        confirmationCtaSecondary:
          ".delivery-confirmation-popup__content--buttons .button--cta-secondary",
        confirmationPopup: ".delivery-confirmation-popup-overlay",
        zipCode: ".delivery-confirmation-popup__content--zip-code",
        zipMessage: ".delivery-confirmation-popup__content--error-message",
        deliveryDate: "#copow-delivery-date",
        deliveryTime: "#copow-delivery-time",
        deliveryDropDown: "#copow-delivery-dropdown-container",
        closeButton: ".delivery-confirmation-popup--close",
        collectionCards: ".card",
        mobileButton: ".copow-sticky-cta",
        mobilePopup: ".copow-delivery-mobile-popup",
        mobilePopupClose: ".copow-delivery-mobile-popup--close",
        productCards: ".product-item.card",
        searchProductCards: ".search-item.cart-item",
      };
      this.init();
    }

    connectedCallback() {
      console.log("Connected callback called");
      this.appURL && this.fetchAppSettings();
    }

    init() {
      console.log(" init called");
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      let firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
      this.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      this.disabledDates = [{ from: firstDayOfMonth, to: yesterday }];

      const sessionData = localStorage.getItem("copow-session");
      console.log("ISSUE > sessionData", sessionData);
      if (sessionData) {
        const parsedData = JSON.parse(sessionData);
        const sessionTimestamp = parsedData.timestamp;
        const currentTime = Date.now();
        console.log("ISSUE", sessionTimestamp, currentTime);
        const sessionAgeHours =
          (currentTime - sessionTimestamp) / (1000 * 60 * 60); // Convert to hours

        if (sessionAgeHours > 24) {
          localStorage.removeItem("copow-session");
        }
      }
      this.mobileButton = document.querySelector(this.selectors.mobileButton);
      this.mobilePopup = document.querySelector(this.selectors.mobilePopup);
      this.mobilePopupClose = document.querySelector(
        this.selectors.mobilePopupClose
      );
      this.popup = document.querySelector(this.selectors.popup);
      this.confirmationPopup = document.querySelector(
        this.selectors.confirmationPopup
      );
      this.closeButton = document.querySelector(this.selectors.closeButton);
      this.confirmationMessage = document.querySelector(
        this.selectors.confirmationMessage
      );
      this.confirmationTitle = document.querySelector(
        this.selectors.confirmationTitle
      );

      this.deliveryDropDownItems = document.querySelectorAll(
        "#copow-delivery-dropdown-container .dropdown-item"
      );

      this.currentState = {};
      this.previousMethod = null;
      this.buttons = document.querySelectorAll(this.selectors.buttons);

      document.addEventListener("DOMContentLoaded", function () {
        this.popup = document.querySelector("#copow-popup");
        let settings = JSON.parse(
          localStorage.getItem("copow-settings") || "{}"
        );
        let appSettings = JSON.parse(
          localStorage.getItem("copow-app-data") || "{}"
        );

        let copowSession = JSON.parse(
          localStorage.getItem("copow-session") || "{}"
        );

        if (settings && Object.entries(settings) == 0) {
          // console.log("FOUND SETTINGS", this.popup);
          this.popup.style.display = "block";
          document.body.style.overflow = "hidden";
        } else {
          if (copowSession && Object.entries(copowSession) == 0) {
            this.popup.style.display = "block";
            document.body.style.overflow = "hidden";
          } else {
            this.popup.style.display = "none";
            document.body.style.overflow = "auto";
          }
        }

        let cartForm = document.querySelector(".cart__form");
        const url = window.location.pathname;
        if (cartForm && url.includes("/cart")) {
          const baseUrl = "/cart";
          const params = new URLSearchParams();
          // console.log("settings==>>>", settings, this.appSettings);
          params.append("checkout[email]", "");
          params.append("discount", "Elevated");
          params.append("auto_redirect", false);
          params.append("edge_redirect", true);
          params.append("skip_shop_pay", true);

          if (settings["Delivery Method"] == "Delivery") {
            params.append("locale", "en-AU");
            params.append("checkout[shipping_address][city]", "");
            params.append("checkout[shipping_address][address1]", "");
            params.append("checkout[shipping_address][address2]", "");
            params.append("checkout[shipping_address][last_name]", "");
            params.append(
              "checkout[shipping_address][zip]",
              settings["Delivery Postal Code"] || ""
            );
            params.append("checkout[shipping_address][province]", "");
            params.append("checkout[shipping_address][state]", "");
            params.append("checkout[shipping_address][country]", "");
            params.append(
              "attributes[Delivery Day]",
              settings["Delivery Day"] || ""
            );
            params.append(
              "attributes[Delivery Date]",
              settings["Delivery Date"] || ""
            );
            params.append(
              "attributes[Delivery Time]",
              settings["Delivery Time"] || ""
            );
            // params.append(
            //   "attributes[Delivery Postal Code]",
            //   settings["Delivery Postal Code"] || ""
            // );
            params.append("attributes[Delivery Method]", "Delivery");
          } else if (settings["Delivery Method"] == "Pick Up") {
            // let address = `${
            //   settings["Location Address"] +
            //   " , " +
            //   settings["Location City"] +
            //   ", " +
            //   settings["Location Province Code"] +
            //   ", " +
            //   settings["Location Country"]
            // }`;
            params.append("locale", "en-CA");
            if (appSettings?.advancePickupSettings?.prepopulatePickup) {
              params.append(
                "checkout[shipping_address][zip]",
                settings["Location Zip"]
              );
              params.append(
                "checkout[shipping_address][city]",
                settings["Location City"] || ""
              );
              params.append(
                "checkout[shipping_address][province]",
                settings["Location Province"] || ""
              );
              params.append(
                "checkout[shipping_address][country]",
                settings["Location Country"] || ""
              );
              params.append(
                "checkout[shipping_address][address1]",
                settings["Location Address"] || ""
              );
              params.append("checkout[shipping_address][address2]", "");
              params.append("checkout[shipping_address][last_name]", "");
              params.append("attributes[Delivery Method]", "Pick Up");
              params.append(
                "attributes[Delivery Day]",
                settings["Delivery Day"] || ""
              );
              params.append(
                "attributes[Delivery Date]",
                settings["Delivery Date"] || ""
              );
              params.append(
                "attributes[Location Address]",
                settings["Location Address"] || ""
              );
              params.append(
                "attributes[Location Zip]",
                settings["Location Zip"] || ""
              );
              params.append(
                "attributes[Location Id]",
                settings["Location Id"] || ""
              );
            }
          } else {
            params.append("locale", "en");
            // params.append("attributes[Customer TimeZone]", "");
            params.append("attributes[Delivery Method]", "Shipping");
          }
          const newURL = `${baseUrl}?${params.toString()}`;
          //   window.history.replaceState({}, "", newURL);
          document.querySelector(".cart__form").action = newURL;
        }

        let mainContainer = document.querySelector(
          "#copow-delivery-dropdown-container"
        );
        let mainTitle = mainContainer.querySelector(
          ".copow-delivery-dropdown-container__summary"
        );
        let selectedItem = mainContainer.querySelector(
          `[data-handle="${settings["Delivery Method"]}"]`
        );
        mainTitle.innerHTML = `${
          settings["Delivery Method"]
            ? `<div style="display: flex;">${
                selectedItem.querySelector(".dropdown-item--wrap").innerHTML
              }</div>`
            : "How would you like to shop?"
        }`;

        // this.disableCheckout();
        // let watchNode = document.body;
        // if (watchNode) {
        //   var observer = new MutationObserver(function () {
        //     // this.enableCheckout();
        //   });
        //   observer.observe(watchNode, {
        //     childList: true,
        //     subtree: true,
        //   });
        // }
      });

      this.mobileButton.addEventListener("click", (e) => {
        console.log("CLICKED, OPEN A NEW POPUP");
        this.mobilePopup.classList.toggle("display-copow-popup");
        document.body.style.overflow = "hidden";
      });

      this.mobilePopupClose.addEventListener("click", (e) => {
        this.mobilePopup.classList.toggle("display-copow-popup");
        document.body.style.overflow = "auto";
      });

      this.closeButton.addEventListener("click", (e) => {
        this.confirmationPopup.style.display = "none";
        document.body.style.overflow = "auto";
      });

      this.buttons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.latestMethod = e.target.dataset.handle;
          // Render the popup with delivery settings...
          if (this.latestMethod === "Delivery") {
            this.renderContent(this.latestMethod);
          } else if (this.latestMethod === "Pick Up") {
            this.renderContent(this.latestMethod);
          } else {
            let settings = this.fetchFromLocalStorage("copow-settings");
            if (
              settings &&
              Object.entries(settings).length > 0 &&
              this.latestMethod !== this.previousMethod
            ) {
              this.previousMethod = settings["Delivery Method"];
              if (
                this.appSettings.shipping?.availability?.dateTimeType == "none"
              ) {
                this.renderConfirmationPopup(
                  this.latestMethod,
                  this.previousMethod
                );
              } else {
                this.renderContent(this.latestMethod);
              }
            } else {
              console.log(
                "this.appSettings.shipping?.availability?.dateTimeType",
                this.appSettings.shipping?.availability?.dateTimeType
              );

              if (
                this.appSettings.shipping?.availability?.dateTimeType == "none"
              ) {
                this.renderConfirmationPopup(
                  this.latestMethod,
                  this.previousMethod
                );
              } else {
                this.renderContent(this.latestMethod);
              }
              // this.currentState["Delivery Method"] = this.latestMethod;
              // this.clearCart();
              // this.updateLocalStorage("copow-settings", this.currentState);
              // this.popup.style.display = "none";
              // document.body.style.overflow = "auto";
            }
          }
          this.currentState["Delivery Method"] = e.target.dataset.handle;
          // this.clearCart();
          // this.updateLocalStorage("copow-settings", this.currentState);
          //   this.popup.style.display = "none";
          //   document.body.style.overflow = "auto";
        });
      });

      this.deliveryDropDownItems?.forEach((item) => {
        item?.addEventListener("click", (e) => {
          let elem = e.target.closest(".dropdown-item");
          this.latestMethod = elem.dataset.handle;
          let settings = this.fetchFromLocalStorage("copow-settings");
          this.currentState = {};
          if (settings && Object.entries(settings).length > 0) {
            if (this.latestMethod == "Delivery") {
              this.renderContent(this.latestMethod);
            } else if (this.latestMethod == "Shipping") {
              if (
                this.appSettings.shipping?.availability?.dateTimeType == "none"
              ) {
                this.renderConfirmationPopup(
                  this.latestMethod,
                  settings["Delivery Method"]
                );
              } else {
                this.renderContent(this.latestMethod);
              }
              // this.currentState["Delivery Method"] = this.latestMethod;
              // this.clearCart();
              // this.updateLocalStorage("copow-settings", this.currentState);
              // this.popup.style.display = "none";
              // document.body.style.overflow = "auto";
              // setTimeout(() => {
              //   location.reload();
              // }, 1000);
            } else if (this.latestMethod == "Pick Up") {
              this.renderContent(this.latestMethod);
            }
          }
        });
      });

      if (this.isShopifyCollectionPage()) {
        this.productCards = document.querySelectorAll(
          this.selectors.productCards
        );
        this.searchProductCards = document.querySelectorAll(
          this.selectors.searchProductCards
        );
        let customlocalStorage = this.fetchFromLocalStorage("copow-settings");
        this.productCards?.forEach((card) => {
          const productId = card.getAttribute("data-product-id");
          const productTags = card.getAttribute("data-product-tags");
          if (
            customlocalStorage &&
            customlocalStorage?.["Delivery Method"] &&
            productId
          ) {
            if (
              !productTags?.includes("Shippable") &&
              customlocalStorage["Delivery Method"] == "Shipping"
            ) {
              card.style.display = "none";
            } else {
              card.style.display = "block";
            }
          }
        });
        this.searchProductCards?.forEach((card) => {
          const productId = card.getAttribute("data-product-id");
          const productTags = card.getAttribute("data-product-tags");
          if (
            customlocalStorage &&
            customlocalStorage?.["Delivery Method"] &&
            productId
          ) {
            if (
              !productTags?.includes("Shippable") &&
              customlocalStorage["Delivery Method"] == "Shipping"
            ) {
              card.style.display = "none";
            } else {
              card.style.display = "block";
            }
          }
        });
      } else if (window?.location?.pathname.includes("/collections")) {
        let customlocalStorage = this.fetchFromLocalStorage("copow-settings");
        let collectionsGrids = document.querySelectorAll(
          ".grid[data-shopping-mode]"
        );
        collectionsGrids.forEach((grid) => {
          let shippingMode = grid.getAttribute("data-shopping-mode");
          if (
            shippingMode != "" &&
            shippingMode != customlocalStorage?.["Delivery Method"]
          ) {
            grid.style.display = "none";
          }
        });
      }
      if (window?.location?.pathname?.includes("/products")) {
        let customlocalStorage = this.fetchFromLocalStorage("copow-settings");
        fetch(window?.location.pathname + ".json")
          .then((response) => response.json())
          .then((response) => {
            let productTags = response?.product?.tags || "";
            if (
              !productTags?.includes("Shippable") &&
              customlocalStorage["Delivery Method"] == "Shipping"
            ) {
              const quickViewContainer = document.createElement("div");
              quickViewContainer.innerHTML = `<modal-box id="modal-shopping-mode"	
								class="modal modal--product" 
								data-options='{
									"enabled": true,
									"showOnce": false,
                  "show": 1
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--small">
									<div class="modal-content" style="background: #E76969">
										<div class="modal-heading">
                      <div class="modal-heading__text">
                        <span class="h4 popup-title" style="color: #FFFFFF">Not available for ${customlocalStorage?.[
                          "Delivery Method"
                        ]?.toLowerCase()}</span>
                      </div>
                    </div>
                    <div class="rte" style="color: #FFFFFF;">
                      Please pick a different shopping mode.
                    </div>
                    <div class="increased-spacing" style="padding-top: 1rem;"><a href="/collections" class="button button--outline button--regular" style="color: #ffffff; border-color: #ffffff;">Continue Shopping</a></div>
									</div>
								</div>
							</modal-box>`;

              this.quickViewModal =
                quickViewContainer.querySelector("modal-box");
              document.body.appendChild(this.quickViewModal);
              this.addToCart = document.querySelector(
                ".product-actions .product-form .add-to-cart"
              );
              this.addToCart.classList.add("disabled");
            }
          });
      }
    }

    fetchAppSettings() {
      fetch(`${this.appURL}/api/ext/settings?shop=${window.Shopify.shop}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((res) => {
          console.log("fetchAppSettings=> success", res?.stores);
          // if (res.status === 200) {
          let data = {
            languages: {
              en: {
                language: "en-US",
                time_label: "Select time",
                time_format: "%l:%M %p", //%l:%M %p => 2:30 PM
                date_format: "M d, Y",
              },
            },
            type: res?.settings?.configLocations,
            shipping: res?.settings?.shippingSettings || {},
            advancePickupSettings: res?.settings?.advancePickupSettings || {},
            currentDeliveryZone: {},
          };
          if (data.type == "different") {
            // find delivery and pickup settings if exists in the locations.
            let pickupSettings = {
              enabled: false,
              locations: [],
            };
            let deliverySettings = {
              enabled: false,
              locations: [],
            };
            if (
              Array.isArray(res?.locations) &&
              res?.locations.length > 0 &&
              Array.isArray(res?.settings?.locationSettings) &&
              res?.settings?.locationSettings?.length > 0
            ) {
              const validPickUpLocations = [];
              res?.locations?.map((loc) => {
                const matched = res?.settings?.locationSettings?.some(
                  (setting) =>
                    setting.id === loc?.locationId && setting?.enablePickup
                );
                if (loc?.pickup?.enabled && loc?.pickup?.settings && matched) {
                  validPickUpLocations.push(loc);
                }
              });
              if (validPickUpLocations.length > 0) {
                // console.log("Pickup LOCATIONS FOUND", validPickUpLocations);
                pickupSettings["locations"] = validPickUpLocations;
                pickupSettings.enabled = true;
              }
              const validDeliveryLocations = res?.locations?.filter((loc) => {
                const match = res?.settings?.locationSettings?.find(
                  (setting) =>
                    setting.id === loc?.locationId && setting?.enableDelivery
                );

                return (
                  loc?.delivery?.enabled && loc.delivery?.settings && match
                );
              });
              if (validDeliveryLocations.length > 0) {
                // console.log("Delivery LOCATIONS FOUND", validDeliveryLocations);
                deliverySettings["locations"] = validDeliveryLocations;
                deliverySettings.enabled = true;
              }
            }
            data = {
              ...data,
              delivery:
                deliverySettings.locations[0]?.delivery?.settings ||
                JSON.parse(res?.settings?.deliverySettings || "{}") ||
                {},
              pickup: {
                ...pickupSettings,
              },
              locations: res?.locations || [],
              stores: res?.stores,
            };
          } else {
            // for same scheduling locations...
            data = {
              ...data,
              pickup: res?.settings?.pickupSettings || {},
              delivery: res?.settings?.deliverySettings || {},
              locations: res?.locations || [],
              stores:
                res?.stores?.filter(
                  (store) =>
                    !store?.name?.toLowerCase()?.includes("mobile pos") &&
                    !store?.name?.toLowerCase()?.includes("copow cafe")
                ) || [],
            };
          }
          this.updateLocalStorage("copow-app-data", data);
          this.appSettings = data;
          // }
        })
        .catch((err) => {
          console.log("fetchAppSettings=> error", err);
          this.appSettings = this.fetchFromLocalStorage("copow-app-data");
        });
    }

    updateLocalStorage = (key, value) => {
      try {
        localStorage.setItem(key, JSON.stringify(value));
        console.log(`Data with key '${key}' saved successfully.`);
      } catch (error) {
        console.error("Error saving data to local storage:", error);
      }
    };

    fetchFromLocalStorage = (key) => {
      try {
        let data = localStorage.getItem(key);
        return JSON.parse(data);
      } catch (error) {
        console.error("Error fetching data from local storage:", error);
      }
    };

    clearCart() {
      fetch("/cart/clear.json", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((cartData) => {
          console.log("CartState=>", cartData);
        });
    }

    renderConfirmationPopup(latestMethod, previousMethod) {
      this.popup.style.display = "none";
      this.confirmationPopup.style.display = "flex";
      document.body.style.overflow = "hidden";
      let content = this.confirmationPopup.querySelector(
        ".delivery-confirmation-popup__content"
      );
      content.innerHTML = ` 
     ${
       latestMethod == "Shipping"
         ? `<p class="delivery-confirmation-popup__content--message">
           ${this.metaData.message.replace("{{method}}", latestMethod)}
         </p>`
         : ""
     }
      <p class="delivery-confirmation-popup__content--title">${
        this.metaData.title
      }</p>
      <div class="delivery-confirmation-popup__content--buttons">
        <button class="button button--solid button--cta-primary">${this.metaData.ctaPrimary.replace(
          "{{method}}",
          latestMethod?.toLowerCase()
        )}</button>
       ${
         previousMethod
           ? `<button class="button button--solid button--cta-secondary">
             ${this.metaData.ctaSecondary.replace(
               "{{previousMethod}}",
               previousMethod?.toLowerCase()
             )}
            </button>`
           : ""
       }
      </div>`;
      this.confirmationCtaPrimary = this.confirmationPopup.querySelector(
        this.selectors.confirmationCtaPrimary
      );
      this.confirmationCtaSecondary = this.confirmationPopup.querySelector(
        this.selectors.confirmationCtaSecondary
      );
      this.confirmationCtaPrimary &&
        this.confirmationCtaPrimary.addEventListener("click", (e) => {
          e.preventDefault();
          this.currentState["Delivery Method"] = this.latestMethod;
          this.latestMethod == "Shipping" ? this.clearCart() : null;
          console.log("asdfasdf > confirmationCtaPrimary");
          this.updateLocalStorage("copow-settings", this.currentState);
          this.updateLocalStorage("copow-session", { timestamp: Date.now() });
          this.confirmationPopup.style.display = "none";
          document.body.style.overflow = "auto";
          setTimeout(() => {
            window.location.href = "/collections";
          }, 1000);
        });
      this.confirmationCtaSecondary &&
        this.confirmationCtaSecondary.addEventListener("click", (e) => {
          e.preventDefault();
          this.confirmationPopup.style.display = "none";
          document.body.style.overflow = "auto";
          return;
        });
    }

    renderContent(latestMethod) {
      console.log("renderContent", latestMethod);

      // this.popup.style.display = "none";
      document.body.style.overflow = "hidden";
      this.confirmationPopup.style.display = "flex";
      let content = this.confirmationPopup.querySelector(
        ".delivery-confirmation-popup__content"
      );
      content.innerHTML = "";
      if (latestMethod == "Shipping") {
        content.innerHTML = `
        ${this.renderCalenderInput(
          this.appSettings.shipping?.availability?.dateTimeType
        )}
        ${this.renderCTAs(latestMethod)}`;
        this.deliveryDatePicker = content.querySelector(
          ".delivery-confirmation-popup__content--date-picker"
        );
        this.deliveryTimePicker = content.querySelector(
          ".delivery-confirmation-popup__content--time-picker"
        );
        if (this.deliveryDatePicker) {
          this.deliveryDatePicker.style.display = "block";
        }
        if (this.deliveryTimePicker) {
          this.deliveryTimePicker.style.display = "block";
        }
      } else if (latestMethod == "Pick Up") {
        if (this.appSettings.type == "different") {
          // for different scheduling locations...
          let validStores = [];
          this.appSettings?.stores?.map((store) =>
            this.appSettings?.pickup?.locations?.map((loc) => {
              if (loc?.locationId == store?.id) {
                validStores.push(store);
              }
            })
          );
          console.log(
            "VALID STORES==>>",
            validStores,
            this.appSettings?.pickup?.locations
          );
          let allStores = validStores
            ?.map((store) => {
              return `
            <div class="delivery-confirmation-popup__content--store" data-id=${store.id} data-address="${store.address.address1}" data-zip="${store.address.zip}" data-city="${store.address.city}" data-province="${store.address.province}" data-province-code="${store.address.provinceCode}" data-country="${store.address.countryCode}">
                <p class="delivery-confirmation-popup__content--store-name">${store.name}</p>
                <p class="delivery-confirmation-popup__content--store-address">${store.address.address1}</p>
                <p class="delivery-confirmation-popup__content--store-phone">${store.address.phone}</p>
                <button class="button button--solid button--cta-primary">Select Store</button>
            </div>
          `;
            })
            ?.join("");

          content.innerHTML = `
        ${
          allStores
            ? `<p class="delivery-confirmation-popup__content--title">Please select a store to pick up your order.</p>
          <div class="delivery-confirmation-popup__content--locations">
              ${allStores}
          </div>`
            : ""
        }
         ${
           this.renderCalenderInput(
             this.appSettings.pickup?.locations[0]?.pickup?.settings
               ?.availability?.dateTimeType
           ) || ""
         }
          ${this.renderCTAs(latestMethod) || ""}`;
        } else {
          let allStores = this.appSettings?.stores
            ?.map((store) => {
              return `
              <div class="delivery-confirmation-popup__content--store" data-id=${store.id} data-address="${store.address.address1}" data-zip="${store.address.zip}" data-city="${store.address.city}" data-province="${store.address.province}" data-province-code="${store.address.provinceCode}" data-country="${store.address.countryCode}">
                  <p class="delivery-confirmation-popup__content--store-name">${store.name}</p>
                  <p class="delivery-confirmation-popup__content--store-address">${store.address.address1}</p>
                  <p class="delivery-confirmation-popup__content--store-phone">${store.address.phone}</p>
                  <button class="button button--solid button--cta-primary">Select Store</button>
              </div>
            `;
            })
            ?.join("");
          content.innerHTML = `
        ${
          allStores
            ? `<p class="delivery-confirmation-popup__content--title">Please select a store to pick up your order.</p>
          <div class="delivery-confirmation-popup__content--locations">
              ${allStores}
          </div>`
            : ""
        }
         ${
           this.renderCalenderInput(
             this.appSettings.pickup?.availability?.dateTimeType
           ) || ""
         }
          ${this.renderCTAs(latestMethod) || ""}`;
        }
        this.startButton = content.querySelector(
          ".delivery-confirmation-popup__content--buttons .button--cta-primary"
        );
        this.startButton.style.display = "none";
        this.storeLocations = content.querySelectorAll(
          ".delivery-confirmation-popup__content--store"
        );
        this.storeButtons = content.querySelectorAll(
          ".delivery-confirmation-popup__content--store .button--cta-primary"
        );
        this.storeButtons.forEach((button) => {
          button.addEventListener("click", (e) => {
            this.storeButtons.forEach((c) => {
              c.textContent = "Select Store";
            });
            button.textContent = "Selected";
            this.currentState["Location Address"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.address;
            this.currentState["Location Id"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.id;
            this.currentState["Location Country"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.country;
            this.currentState["Location Province"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.province;
            this.currentState["Location Province Code"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.provinceCode;
            this.currentState["Location City"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.city;
            this.currentState["Location Zip"] = e.target.closest(
              ".delivery-confirmation-popup__content--store"
            )?.dataset.zip;
            // this.startButton.style.display = "block";
            this.startButton.disabled = false;
            this.startButton.classList.remove("disabled");

            this.deliveryDatePicker = document.querySelector(
              ".delivery-confirmation-popup__content--date-picker"
            );
            this.deliveryTimePicker = document.querySelector(
              ".delivery-confirmation-popup__content--time-picker"
            );
            if (this.deliveryDatePicker) {
              this.deliveryDatePicker.style.display = "block";
            }
            if (this.deliveryTimePicker) {
              this.deliveryTimePicker.style.display = "block";
            }

            if (this.appSettings.type == "different") {
              let deliveryMethod = this.appSettings?.pickup?.locations?.find(
                (loc) => loc.locationId == this.currentState["Location Id"]
              );
              deliveryMethod &&
                this.initializeFlatPickr(deliveryMethod?.pickup?.settings);
            }
            console.log(this.currentState);
          });
        });
      } else if (latestMethod === "Delivery") {
        content.innerHTML = `
          <div class="delivery-confirmation-popup__content--zip-code">
            <p class="delivery-confirmation-popup__content--title">Please enter your zip code to start your local delivery order.</p>
            <input
            id="zip-code-input"
            class="copow__input delivery-confirmation-popup__content--zip-code-input"
            type="text"
            data-zip-code-input
            placeholder="Enter your zip code">
            <p class="delivery-confirmation-popup__content--error-message" data-zip-error-message></p>
          </div>
          <div id="delivery-extra-fields"></div>
          `;

        // ${
        //   this.renderCalenderInput(
        //     this.appSettings.delivery?.availability?.dateTimeType
        //   ) || ""
        // }
        // ${this.renderCTAs(latestMethod) || ""}

        this.zipCode = content.querySelector(this.selectors.zipCode);
        this.zipCode.style.display = "flex";
        this.zipCodeInput = content.querySelector("#zip-code-input");
        this.zipCodeInput.addEventListener("input", (e) => {
          // this.startButton.disabled = true;
          // this.startButton.classList.add("disabled");
          if (this.checkDeliveryAvailability(e.target)) {
            console.log("THE ZONE ==>>", this.appSettings?.currentDeliveryZone);
            this.startButton = content.querySelector(
              ".delivery-confirmation-popup__content--buttons .button--cta-primary"
            );
            this.startButton.style.display = "none";
            if (this.startButton) {
              this.startButton.disabled = false;
              this.startButton.classList.remove("disabled");
              this.timePicker = content.querySelector(
                this.selectors.deliveryTime
              );
              this.timePicker &&
                this.timePicker?.addEventListener("change", (e) => {
                  this.currentState["Delivery Time"] = e.target.value;
                  // console.log(e.target.value);
                  this.startButton.disabled = false;
                  this.startButton.classList.remove("disabled");
                });

              this.startButton.addEventListener("click", (e) => {
                let settings = this.fetchFromLocalStorage("copow-settings");
                console.log("LATEST==>>", this.latestMethod);
                if (
                  settings &&
                  Object.entries(settings).length > 0 &&
                  this.latestMethod !== settings["Delivery Method"]
                ) {
                  this.previousMethod = settings["Delivery Method"];
                  this.renderConfirmationPopup(
                    this.latestMethod,
                    this.previousMethod
                  );
                  return;
                }
                this.currentState["Delivery Method"] = latestMethod;
                latestMethod == "Shipping" ? this.clearCart() : null;
                this.updateLocalStorage("copow-settings", this.currentState);
                this.updateLocalStorage("copow-session", {
                  timestamp: Date.now(),
                });
                this.popup.style.display = "none";
                this.confirmationPopup.style.display = "none";
                document.body.style.overflow = "auto";
                setTimeout(() => {
                  window.location.href = "/collections";
                }, 1000);
              });

              this.loadFlatPickrLibrary()
                .then(() => {
                  console.log("FLATFLATFLAT");
                  this.waitForFlatPickr()
                    .then(() => {
                      console.log("LOADED FLAT", latestMethod);
                      let deliveryMethod =
                        this.appSettings.currentDeliveryZone?.settings;
                      if (latestMethod == "Shipping")
                        deliveryMethod = this.appSettings.shipping;
                      if (this.appSettings.type == "different") {
                        if (latestMethod == "Delivery")
                          deliveryMethod = this.appSettings.delivery;
                        // this.initializeFlatPickr(deliveryMethod);
                        // console.log("FOR DELIVERY METHOD", this.currentState);
                      } else {
                        if (latestMethod == "Delivery")
                          deliveryMethod =
                            this.appSettings.currentDeliveryZone?.settings;
                        if (latestMethod == "Pick Up")
                          deliveryMethod = this.appSettings.pickup;
                      }
                      this.initializeFlatPickr(deliveryMethod);
                    })
                    .catch((err) => {
                      console.log("EROROROROROROOR.. waitForFlatPickr", err);
                    });
                })
                .catch(() => {
                  console.log("EROROROROROROOR..loadFlatPickrLibrary");
                });
            }
          }
        });
        return true;
      }

      this.startButton = content.querySelector(
        ".delivery-confirmation-popup__content--buttons .button--cta-primary"
      );

      this.timePicker = content.querySelector(this.selectors.deliveryTime);
      this.timePicker &&
        this.timePicker?.addEventListener("change", (e) => {
          this.currentState["Delivery Time"] = e.target.value;
          console.log(e.target.value);
          this.startButton.disabled = false;
          this.startButton.classList.remove("disabled");
        });
      this.startButton.addEventListener("click", (e) => {
        let settings = this.fetchFromLocalStorage("copow-settings");
        console.log("LATEST==>>", this.latestMethod);

        if (
          settings &&
          Object.entries(settings).length > 0 &&
          this.latestMethod !== settings["Delivery Method"]
        ) {
          this.previousMethod = settings["Delivery Method"];
          this.renderConfirmationPopup(this.latestMethod, this.previousMethod);
          //   this.confirmationCtaPrimary = this.confirmationPopup.querySelector(
          //     this.selectors.confirmationCtaPrimary
          //   );
          //   this.confirmationCtaSecondary = this.confirmationPopup.querySelector(
          //     this.selectors.confirmationCtaSecondary
          //   );
          //   this.confirmationCtaPrimary.addEventListener("click", (e) => {
          //     e.preventDefault();
          //     this.currentState["Delivery Method"] = latestMethod;
          //     this.clearCart();
          //     this.updateLocalStorage("copow-settings", this.currentState);
          //     this.confirmationPopup.style.display = "none";
          //     document.body.style.overflow = "auto";
          //   });
          //   this.confirmationCtaSecondary.addEventListener("click", (e) => {
          //     e.preventDefault();
          //     this.confirmationPopup.style.display = "none";
          //     document.body.style.overflow = "auto";
          //     return;
          //   });
          return;
        }
        this.currentState["Delivery Method"] = latestMethod;
        latestMethod == "Shipping" || this.previousMethod == "Shipping"
          ? this.clearCart()
          : null;
        this.updateLocalStorage("copow-settings", this.currentState);
        this.updateLocalStorage("copow-session", { timestamp: Date.now() });
        this.popup.style.display = "none";
        this.confirmationPopup.style.display = "none";
        document.body.style.overflow = "auto";
        setTimeout(() => {
          window.location.href = "/collections";
        }, 1000);
      });

      this.loadFlatPickrLibrary()
        .then(() => {
          console.log("FLATFLATFLAT");
          this.waitForFlatPickr()
            .then(() => {
              console.log("LOADED FLAT", latestMethod);
              let deliveryMethod = this.appSettings.delivery;
              if (latestMethod == "Shipping")
                deliveryMethod = this.appSettings.shipping;
              if (this.appSettings.type == "different") {
                if (latestMethod == "Delivery")
                  deliveryMethod = this.appSettings.delivery;
                // this.initializeFlatPickr(deliveryMethod);
                // console.log("FOR DELIVERY METHOD", this.currentState);
              } else {
                if (latestMethod == "Delivery")
                  deliveryMethod = this.appSettings.delivery;
                if (latestMethod == "Pick Up")
                  deliveryMethod = this.appSettings.pickup;
              }
              this.initializeFlatPickr(deliveryMethod);
            })
            .catch((err) => {
              console.log("EROROROROROROOR.. waitForFlatPickr", err);
            });
        })
        .catch(() => {
          console.log("EROROROROROROOR..loadFlatPickrLibrary");
        });
    }

    renderCTAs(method) {
      return `
        <div
        id="copow-spinner"
        class="copow-spinner"
        style="display: none;"></div>

        <div class="delivery-confirmation-popup__content--buttons">
          <button disabled class="button button--solid button--cta-primary disabled">Start Your ${method} Order</button>
        </div>`;
    }

    renderCalenderInput(type) {
      console.log("renderCalenderInput", type);
      switch (type) {
        case "date":
          return `
          <div class="delivery-confirmation-popup__content--date-picker">
          <p class="delivery-confirmation-popup__content--title">Please select a ${this.latestMethod?.toLowerCase()} date for your order.</p>
              <input
                data-date-input
                class="copow__input delivery-date"
                type="date"
                id="copow-delivery-date"
                name="attributes[delivery-date]"
                placeholder="Choose a Date">
            </div>`;
        case "datetime":
          return `
          <div class="delivery-confirmation-popup__content--date-picker">
          <p class="delivery-confirmation-popup__content--title">Please select a delivery date & time for your order.</p>
              <input
                data-date-input
                class="copow__input delivery-date"
                type="date"
                id="copow-delivery-date"
                name="attributes[delivery-date]"
                placeholder="Choose a Date">
            </div>

            <div class="delivery-confirmation-popup__content--time-picker">
              <select
                class="copow__input delivery-time"
                data-time-slot
                id="copow-delivery-time"
                name="attributes[delivery-time]"
                placeholder="Select Time">
                <option
                  value=""
                  disabled
                  selected>No delivery time available</option>
              </select>
              </div>`;
        case "range":
          console.log("IN RANGE/......");
          return `
          <div class="delivery-confirmation-popup__content--date-picker">
          <p class="delivery-confirmation-popup__content--title">Please select a delivery date & time for your order.</p>
              <input
                data-date-input
                class="copow__input delivery-date"
                type="date"
                id="copow-delivery-date"
                name="attributes[delivery-date]"
                placeholder="Choose a Date">
            </div>

            <div class="delivery-confirmation-popup__content--time-picker">
              <select
                class="copow__input delivery-time"
                data-time-slot
                id="copow-delivery-time"
                name="attributes[delivery-time]"
                placeholder="Select Time">
                <option
                  value=""
                  disabled
                  selected>No delivery time available</option>
              </select>
              </div>`;
        default:
          console.log("DEFAULT /......");
          return "";
      }
    }

    // generateRangeTimeSlots() {
    //   let options = "";

    //   // Loop over 24 hours, 15-minute intervals
    //   for (let startHour = 0; startHour < 24; startHour++) {
    //     for (let startMinute = 0; startMinute < 60; startMinute += 15) {
    //       const endHour = startHour + Math.floor((startMinute + 15) / 60);
    //       const endMinute = (startMinute + 15) % 60;

    //       const startTime = this.formatTime(startHour, startMinute);
    //       const endTime = this.formatTime(endHour, endMinute);

    //       const optionValue = `${startTime} - ${endTime}`;

    //       options += `<option value="${optionValue}">${optionValue}</option>`;
    //     }
    //   }

    //   return options;
    // }

    formatTime(hour, minute) {
      const period = hour < 12 ? "AM" : "PM";
      const hour12 = hour % 12 || 12; // Convert to 12-hour format
      return `${hour12}:${minute.toString().padStart(2, "0")} ${period}`;
    }

    generateTimeSlots(startTime, endTime = "", dateTimeType) {
      // Convert start and end time into Date objects
      const start = new Date(`01/01/2025 ${startTime}`);
      const end = endTime ? new Date(`01/01/2025 ${endTime}`) : null;

      let options = "";

      // Loop from start time to end time with 15-minute intervals
      if (!end || dateTimeType == "datetime") {
        const todayDate = start.getDate();
        for (
          let current = start;
          current.getDate() === todayDate;
          current.setMinutes(current.getMinutes() + 15)
        ) {
          const timeFormatted = this.formatTime(
            current.getHours(),
            current.getMinutes()
          );

          options += `<option value="${timeFormatted}">${timeFormatted}</option>`;
        }
      } else {
        for (
          let current = start;
          current < end;
          current.setMinutes(current.getMinutes() + 15)
        ) {
          const next = new Date(current); // Clone current time for the end time
          next.setMinutes(current.getMinutes() + 15); // Set the next time 15 minutes ahead

          const startFormatted = this.formatTime(
            current.getHours(),
            current.getMinutes()
          );
          const endFormatted = this.formatTime(
            next.getHours(),
            next.getMinutes()
          );

          // Create the option in "start - end" format
          options += `<option value="${startFormatted} - ${endFormatted}">${startFormatted} - ${endFormatted}</option>`;
        }
      }

      return options;
    }

    // generateRangeTimeSlots(startTime, endTime) {
    //   let options = "";

    //   for (let startHour = 0; startHour < 24; startHour++) {
    //     for (let startMinute = 0; startMinute < 60; startMinute += 15) {
    //       const endHour = startHour + Math.floor((startMinute + 15) / 60);
    //       const endMinute = (startMinute + 15) % 60;

    //       const startTime = this.formatTime(startHour, startMinute);
    //       const endTime = this.formatTime(endHour, endMinute);

    //       const optionValue = `${startTime} - ${endTime}`;

    //       options += `<option value="${optionValue}">${optionValue}</option>`;
    //     }
    //   }

    //   return options;
    // }

    // generateSingleTimeSlots() {
    //   let options = "";

    //   for (let startHour = 0; startHour < 24; startHour++) {
    //     for (let startMinute = 0; startMinute < 60; startMinute += 15) {
    //       const startTime = this.formatTime(startHour, startMinute);

    //       const optionValue = `${startTime}`;

    //       options += `<option value="${optionValue}">${optionValue}</option>`;
    //     }
    //   }

    //   return options;
    // }

    isZipValid(zipCode) {
      const zipPatterns = this.appSettings?.delivery?.postalCodes?.postalCodes
        .split(",")
        .map((zip) => new RegExp("^" + zip.replace(/\*/g, "\\d") + "$"));
      return zipPatterns?.some((pattern) => pattern.test(zipCode));
    }

    getZoneByZip(zipCode, deliveryZones) {
      for (const zone of deliveryZones) {
        const zipPatterns = zone?.postalCodes
          .split(",")
          .map((zip) => new RegExp("^" + zip.replace(/\*/g, "\\d") + "$"));

        const isValid =
          zipPatterns?.some((pattern) => pattern.test(zipCode)) || false;
        if (isValid) {
          return {
            isValid: true,
            zone,
          };
        }
      }

      return {
        isValid: this.isZipValid(zipCode) || false,
        zone: null,
      };
    }

    checkDeliveryAvailability(target) {
      const zipCode = target.value;
      this.zipMessage = document.querySelector(this.selectors.zipMessage);
      this.deliveryDatePicker = document.querySelector(
        ".delivery-confirmation-popup__content--date-picker"
      );
      this.deliveryTimePicker = document.querySelector(
        ".delivery-confirmation-popup__content--time-picker"
      );

      let result = {
        isValid: false,
        zone: null,
      };

      if (this.appSettings.type == "same") {
        result = this.getZoneByZip(
          zipCode,
          this.appSettings?.delivery?.deliveryZones
        );
      } else {
        let zone = this.appSettings?.locations?.find(
          (itm) => itm.locationName == "Kitchen"
        )?.delivery;
        const zipPatterns = this.appSettings?.locations
          ?.find((itm) => itm.locationName == "Kitchen")
          ?.delivery?.settings?.postalCodes?.postalCodes.split(",")
          .map((zip) => new RegExp("^" + zip.replace(/\*/g, "\\d") + "$"));

        result = {
          isValid: zipPatterns?.some((pattern) => pattern.test(zipCode)),
          zone: zone,
        };
      }

      if (result?.isValid) {
        this.appSettings.currentDeliveryZone = result?.zone || {};

        const availabilityType =
          this.appSettings?.currentDeliveryZone?.settings?.availability
            ?.dateTimeType;

        let content = this.confirmationPopup.querySelector(
          ".delivery-confirmation-popup__content"
        );

        this.extraFieldsContainer = content.querySelector(
          "#delivery-extra-fields"
        );

        this.extraFieldsContainer.innerHTML = `
        ${this.renderCalenderInput(availabilityType) || ""}
        ${this.renderCTAs(this.latestMethod) || ""}
          `;

        this.deliveryDatePicker = document.querySelector(
          ".delivery-confirmation-popup__content--date-picker"
        );
        this.deliveryTimePicker = document.querySelector(
          ".delivery-confirmation-popup__content--time-picker"
        );

        this.zipMessage.textContent = "Local delivery available.";
        this.zipMessage.style.color = "green";
        if (this.deliveryDatePicker) {
          this.deliveryDatePicker.style.display = "block";
        }
        if (this.deliveryTimePicker) {
          this.deliveryTimePicker.style.display = "block";
        }
        this.currentState["Delivery Postal Code"] = zipCode;
        return true;
      } else {
        this.appSettings.currentDeliveryZone = {};
        this.zipMessage.textContent = "Local delivery not available.";
        this.zipMessage.style.color = "red";
        if (this.deliveryDatePicker) {
          this.deliveryDatePicker.style.display = "none";
        }
        if (this.deliveryTimePicker) {
          this.deliveryTimePicker.style.display = "none";
        }
        this.currentState["Delivery Postal Code"] = "";
        return false;
      }
    }

    async loadFlatPickrLibrary() {
      return new Promise((resolve, reject) => {
        const embedLocation = document.head;
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/flatpickr";
        script.onload = () => {
          const link = document.createElement("link");
          link.rel = "stylesheet";
          //   link.href = "https://npmcdn.com/flatpickr/dist/themes/dark.css";
          link.href =
            "https://cdn.jsdelivr.net/npm/flatpickr/dist/flatpickr.min.css";
          embedLocation.appendChild(link);
          resolve();
        };
        script.onerror = () => {
          reject(new Error("Failed to load the FlatPickr Script from CDN"));
        };
        embedLocation.appendChild(script);
      });
    }

    waitForFlatPickr() {
      console.log("==>>waitForFlatpickr called");
      return new Promise((resolve) => {
        const checkFlatpickr = () => {
          console.log("==>>checkFlatpickr called");
          if (typeof flatpickr !== "undefined") {
            resolve();
          } else {
            setTimeout(checkFlatpickr, 100); // Check again after 100 milliseconds
          }
        };
        checkFlatpickr();
      });
    }

    initializeFlatPickr(deliveryMethod) {
      this.dateInput = document.querySelector("#copow-delivery-date");
      console.log(
        "initializeFlatPick==>>>",
        this.disabledDates,
        this.dateInput,
        deliveryMethod
      );
      this.dateInput &&
        flatpickr(this.dateInput, {
          altInputClass: "delivery-confirmation-popup__content--date-picker",
          inline: false,
          altFormat: "Y-m-d",
          dateFormat: this.appSettings.languages.en.date_format,
          onChange: (selectedDates, dateStr, instance) => {
            this.showSpinner();
            setTimeout(() => {
              this.hideSpinner();
              this.startButton.style.display = "block";
            }, 600);
            const formattedDate =
              instance?.latestSelectedDateObj?.toLocaleDateString("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              });
            const { DateTime } = luxon;
            const nowInLocalTZ = DateTime.now();
            const zone = "America/Denver";
            // previously....
            // const dateObj1 = new Date(dateStr + " 00:00:00 UTC");
            // const dayName = dateObj1.toLocaleDateString("en-US", {
            //   weekday: "short",
            // });
            const dateObj = DateTime.fromFormat(dateStr, "MMM dd, yyyy", {
              zone,
            });
            const dayName = dateObj.toLocaleString({ weekday: "short" });
            this.currentState["Delivery Date"] = dateStr;
            this.currentState["Delivery Day"] = dayName;
            // console.log(dateStr, dayName);
            const timePicker = document.querySelector(
              this.selectors.deliveryTime
            );

            if (
              timePicker &&
              !deliveryMethod?.availability?.sameAvailability &&
              deliveryMethod?.availability?.availability[dayName]?.slots
            ) {
              let timeOptions = this.generateTimeSlots(
                deliveryMethod?.availability?.availability[dayName]?.slots[0]
                  ?.start,
                deliveryMethod?.availability?.availability[dayName]?.slots[0]
                  ?.end,
                deliveryMethod?.availability?.dateTimeType
              );
              if (timeOptions) {
                timePicker.innerHTML =
                  "<option value='' disabled selected>Select Time</option>";

                timePicker.innerHTML += timeOptions;
              } else {
                timePicker.innerHTML =
                  "<option value='' disabled selected>No delivery time available</option>";
              }
            } else if (
              timePicker &&
              deliveryMethod?.availability?.sameAvailability &&
              deliveryMethod?.availability?.availability?.globalSlots
            ) {
              let timeOptions = this.generateTimeSlots(
                deliveryMethod?.availability?.availability?.globalSlots?.start,
                deliveryMethod?.availability?.availability?.globalSlots?.end,
                deliveryMethod?.availability?.dateTimeType
              );
              if (timeOptions) {
                timePicker.innerHTML =
                  "<option value='' disabled selected>Select Time</option>";

                timePicker.innerHTML += timeOptions;
              } else {
                timePicker.innerHTML =
                  "<option value='' disabled selected>No delivery time available</option>";
              }
            }
            this.startButton = document.querySelector(
              ".delivery-confirmation-popup__content--buttons .button--cta-primary"
            );
            this.startButton.disabled = false;
            this.startButton.classList.remove("disabled");
          },
          onMonthChange: () => {},
          disable: [
            ...this.disabledDates,
            (date) => {
              const formattedDate = date.toISOString().split("T")[0]; // Extract YYYY-MM-DD
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
              const day = String(date.getDate()).padStart(2, "0");
              let dateValue = `${year}-${month}-${day}`;
              let match = deliveryMethod.blockoutDates?.dates?.find(
                (item) => dateValue == item?.date
              );
              // console.log(
              //   "=====>>>>>",
              //   deliveryMethod,
              //   formattedDate,
              //   `${year}-${month}-${day}`,
              //   date
              // );
              if (match) return true;
              const dayName = date.toLocaleDateString("en-US", {
                weekday: "short",
              });

              if (!deliveryMethod?.availability?.availability[dayName]?.enabled)
                return true;

              if (
                this.isDateAfterVisibleDays(
                  dateValue,
                  deliveryMethod?.blockoutDates?.availableDays || "90"
                )
              )
                return true;

              if (deliveryMethod?.preparationTime?.enabled) {
                return validateDateWithPrepTimeSettings(
                  date,
                  deliveryMethod.preparationTime
                );
              }

              return false;
            },
          ],
        });
    }

    isDateAfterVisibleDays(dateToCheck, days) {
      const { DateTime } = luxon;
      const nowInLocalTZ = DateTime.now();
      const zone = "America/Denver";
      const today = nowInLocalTZ.setZone(zone);
      // const today = new Date();

      let parsedDays = typeof days == "string" ? parseInt(days) : days;
      let lastVisibleDate = today;
      lastVisibleDate = today.plus({ days: parsedDays });

      // console.log(
      //   "DATE CHECKER===>>>",
      //   new Date(dateToCheck) > lastVisibleDate,
      //   parsedDays
      // );

      const dateToCheckObj = DateTime.fromFormat(dateToCheck, "yyyy-MM-dd", {
        zone: zone,
      });
      const isAfter =
        dateToCheckObj?.isValid && dateToCheckObj > lastVisibleDate;

      return isAfter;
    }

    showSpinner() {
      const spinner = document.getElementById("copow-spinner");
      spinner.style.display = "block"; // Make spinner visible
    }

    hideSpinner() {
      const spinner = document.getElementById("copow-spinner");
      spinner.style.display = "none"; // Hide spinner once the operation is complete
    }

    isShopifyCollectionPage() {
      const url = window.location.pathname;
      return url.includes("/collections/") || url.includes("/search");
    }

    disableCheckout() {
      document.body
        .querySelectorAll(this.checkoutSelectors)
        .forEach(function (node) {
          node.addEventListener("click", this.blockEvent, true);
          node.classList.add("copow-disable-node");
        });
    }

    enableCheckout() {
      document.body
        .querySelectorAll(checkoutSelectors)
        .forEach(function (node) {
          node.removeEventListener("click", this.blockEvent, true);
          node.classList.remove("copow-disable-node");
        });
    }

    blockEvent(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }
  customElements.define("copow-popup", DeliveryOptions);
}

function validateDateWithPrepTimeSettings(date, prepTimeSettings) {
  const { DateTime } = luxon;
  const nowInLocalTZ = DateTime.now();
  const zone = "America/Denver";
  const nameOfTheWeekDay = nowInLocalTZ.weekdayLong;

  const {
    cutOffTime,
    leadTime,
    leadTimeUnit,
    leadTimeAfterCutOffTime,
    leadTimeAfterCutOffTimeUnit,
  } = getPrepSettingsForTheDay(
    prepTimeSettings?.optionSelected == "same" ? null : nameOfTheWeekDay,
    prepTimeSettings
  );

  let { now, leadStartDate, cutOffDateTime } = getDateSettings({
    cutOffTime,
    leadTime,
    leadTimeUnit,
    leadTimeAfterCutOffTime,
    leadTimeAfterCutOffTimeUnit,
  });

  const minDateFormatted = leadStartDate.toString().split("T")[0];
  const deliveryDateFormatted = date.toISOString().split("T")[0];

  // console.log(nameOfTheWeekDay, minDateFormatted > deliveryDateFormatted, now.toString(), minDateFormatted, deliveryDateFormatted)
  return minDateFormatted > deliveryDateFormatted;
}

function getPrepSettingsForTheDay(day, prepTimeSettings) {
  const prepSettings = {
    cutOffTime: "",
    leadTime: 0,
    leadTimeAfterCutOffTime: 0,
    leadTimeUnit: "Days",
    leadTimeAfterCutOffTimeUnit: "Days",
  };
  if (day === null) {
    (prepSettings.cutOffTime = prepTimeSettings?.cutOffTime),
      (prepSettings.leadTime = parseInt(prepTimeSettings?.leadTime || "0", 10)),
      (prepSettings.leadTimeUnit =
        prepTimeSettings?.leadTimeBeforeUnit || "Days"),
      (prepSettings.leadTimeAfterCutOffTime = parseInt(
        prepTimeSettings?.leadTimeAfter || "0",
        10
      )),
      (prepSettings.leadTimeAfterCutOffTimeUnit =
        prepTimeSettings?.leadTimeAfterUnit || "Days");
  } else {
    prepSettings.cutOffTime = prepTimeSettings?.cutOffTimes?.[day] || "";
    prepSettings.leadTime = parseInt(
      prepTimeSettings?.leadTimes?.[day] || "0",
      10
    );
    prepSettings.leadTimeUnit =
      prepTimeSettings?.leadTimeBeforeUnit?.[day] || "Days";
    prepSettings.leadTimeAfterCutOffTime = parseInt(
      prepTimeSettings?.leadTimesAfter[day] || "0",
      10
    );
    prepSettings.leadTimeAfterCutOffTimeUnit =
      prepTimeSettings?.leadTimeAfterUnit[day] || "Days";
  }

  return prepSettings;
}

function getDateSettings({
  cutOffTime,
  leadTime,
  leadTimeUnit,
  leadTimeAfterCutOffTime,
  leadTimeAfterCutOffTimeUnit,
}) {
  const { DateTime } = luxon;
  const nowInLocalTZ = DateTime.now();
  const zone = "America/Denver";

  let leadStartDate = nowInLocalTZ.setZone(zone);
  let cutOffDateTime = nowInLocalTZ.setZone(zone);
  let now = nowInLocalTZ.setZone(zone);

  if (cutOffTime && cutOffTime?.length) {
    // cutoff time was set up

    const [cutOffHour, cutOffMinuteWithMeridian] = cutOffTime.split(":");
    const [cutOffMinute, meridian] = cutOffMinuteWithMeridian.split(" ");
    let hour = parseInt(cutOffHour, 10);
    const minute = parseInt(cutOffMinute, 10);

    if (meridian.toLowerCase() === "pm" && hour !== 12) {
      hour += 12;
    }
    if (meridian.toLowerCase() === "am" && hour === 12) {
      hour = 0;
    }

    cutOffDateTime = cutOffDateTime.set({
      hour,
      minute,
      second: 0,
      milliseconds: 0,
    });

    if (now > cutOffDateTime) {
      // the cutoff time has passed
      const key =
        leadTimeAfterCutOffTimeUnit == "Days"
          ? "days"
          : leadTimeAfterCutOffTimeUnit == "Hours"
          ? "hours"
          : "minutes";
      leadStartDate = leadStartDate.plus({ [key]: leadTimeAfterCutOffTime });
    } else {
      // the cutoff time has not passed

      const key =
        leadTimeUnit == "Days"
          ? "days"
          : leadTimeUnit == "Hours"
          ? "hours"
          : "minutes";
      leadStartDate = leadStartDate.plus({ [key]: leadTime });
    }
  } else {
    // cutoff time is blank, meaning leadTimeAfterCutOffTime is to be ignored

    const key =
      leadTimeUnit == "Days"
        ? "days"
        : leadTimeUnit == "Hours"
        ? "hours"
        : "minutes";
    leadStartDate = leadStartDate.plus({ [key]: leadTime });
  }

  return {
    leadStartDate,
    cutOffDateTime,
    now,
  };
}
